import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "@/mixins/infoList";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
import { guanqiaStartLog } from "@/api/data";
import { getGameServerMap } from "@/utils/dictionary";
export default {
  components: {
    serverList: serverList,
    timeDateOptions: timeDateOptions
  },
  name: "guanqiaStartLog",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: guanqiaStartLog,
      partnerArray: [],
      serverList: {},
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      searchInfo: {}
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameServerMap();
            case 2:
              _this.serverList = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent(e) {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      this.getTableData();
    }
  }
};